﻿(function() {
  const form = document.getElementById('RoomMockupForm');
  if (!form) return;

  const panelStep1 = document.getElementById('mockup-panel-1');
  const panelStep2 = document.getElementById('mockup-panel-2');
  const panelSuccess = document.getElementById('mockup-panel-success');
  const stepTab1 = document.getElementById('mockup-step-tab-1');
  const stepTab2 = document.getElementById('mockup-step-tab-2');
  const stepperConnector = document.getElementById('mockup-stepper-connector');

  const continueBtn = document.getElementById('MockupForm-continue-btn');
  const editStep1Btn = document.getElementById('mockup-edit-step1-btn');
  const finishBtn = document.getElementById('MockupForm-finish-btn');
  const dropboxBtn = document.getElementById('mockup-dropbox-launch-btn');
  const copyRefBtn = document.getElementById('mockup-summary-copy-btn');
  const returnPrompt = document.getElementById('mockup-return-prompt');

  // Input elements
  const inputName = document.getElementById('MockupForm-name');
  const inputEmail = document.getElementById('MockupForm-email');
  const inputWidth = document.getElementById('MockupForm-width');
  const inputHeight = document.getElementById('MockupForm-height');
  const inputDesign = document.getElementById('MockupForm-design');
  const inputRef = document.getElementById('MockupForm-reference');
  const inputTime = document.getElementById('MockupForm-submission-time');

  // Summary display elements
  const summaryRef = document.getElementById('mockup-summary-ref');
  const summaryName = document.getElementById('mockup-summary-name');
  const summaryEmail = document.getElementById('mockup-summary-email');
  const summaryDim = document.getElementById('mockup-summary-dimensions');
  const summaryDesign = document.getElementById('mockup-summary-design');
  const syncEmailTag = document.getElementById('mockup-sync-email-tag');
  const syncRefTag = document.getElementById('mockup-sync-ref-tag');

  // Success display elements
  const successRef = document.getElementById('mockup-success-ref');
  const successName = document.getElementById('mockup-success-name');
  const successEmail = document.getElementById('mockup-success-email');

  // Generate or retrieve persistent Reference ID
  function getOrCreateReferenceId() {
    let ref = '';
    try {
      ref = sessionStorage.getItem('xwallx_mockup_ref') || '';
    } catch (e) {}

    if (!ref) {
      const rand = Math.floor(1000 + Math.random() * 9000);
      ref = 'XW-ROOM-' + rand;
      try {
        sessionStorage.setItem('xwallx_mockup_ref', ref);
      } catch (e) {}
    }

    if (inputRef) inputRef.value = ref;
    if (inputTime) inputTime.value = new Date().toISOString();
    return ref;
  }

  // Populate Step 2 & Success with live Step 1 data
  function updateSummary() {
    const ref = getOrCreateReferenceId();
    const name = inputName ? inputName.value.trim() : '';
    const email = inputEmail ? inputEmail.value.trim() : '';
    const width = inputWidth ? inputWidth.value.trim() : '';
    const height = inputHeight ? inputHeight.value.trim() : '';
    const design = (inputDesign && inputDesign.value.trim()) ? inputDesign.value.trim() : 'Any / In-House Curated';

    if (summaryRef) summaryRef.textContent = '#' + ref;
    if (summaryName) summaryName.textContent = name || 'Customer';
    if (summaryEmail) summaryEmail.textContent = email || 'â€”';
    if (summaryDim) summaryDim.textContent = (width && height) ? width + ' Ã— ' + height : (width || height || 'â€”');
    if (summaryDesign) summaryDesign.textContent = design;
    if (syncEmailTag) syncEmailTag.textContent = email || 'your email';
    if (syncRefTag) syncRefTag.textContent = '#' + ref;

    if (successRef) successRef.textContent = '#' + ref;
    if (successName) successName.textContent = name || 'Friend';
    if (successEmail) successEmail.textContent = email || 'your email';
  }

  // Advance to Step 2
  function goToStep2() {
    updateSummary();

    // Background silent sync to Shopify Contact Form API
    try {
      const formData = new FormData(form);
      formData.set('contact[step]', 'Step 1 Complete / Navigated to Dropbox');
      fetch(form.action || '/contact', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).catch(function(err) {
        // Graceful fallback: non-blocking
      });
    } catch (e) {}

    // Switch Panels
    if (panelStep1) panelStep1.style.display = 'none';
    if (panelStep2) {
      panelStep2.style.display = 'block';
    }

    // Update Stepper
    if (stepTab1) {
      stepTab1.classList.remove('mockup-stepper__step--active');
      stepTab1.classList.add('mockup-stepper__step--completed');
      stepTab1.setAttribute('aria-selected', 'false');
    }
    if (stepperConnector) {
      stepperConnector.classList.add('mockup-stepper__connector--completed');
    }
    if (stepTab2) {
      stepTab2.classList.remove('mockup-stepper__step--inactive');
      stepTab2.classList.add('mockup-stepper__step--active');
      stepTab2.setAttribute('aria-selected', 'true');
    }

    // Smooth scroll to card
    const card = document.getElementById('mockup-form-section');
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Return to Step 1
  function goToStep1() {
    if (panelStep2) panelStep2.style.display = 'none';
    if (panelStep1) panelStep1.style.display = 'block';

    if (stepTab2) {
      stepTab2.classList.remove('mockup-stepper__step--active');
      stepTab2.classList.add('mockup-stepper__step--inactive');
      stepTab2.setAttribute('aria-selected', 'false');
    }
    if (stepperConnector) {
      stepperConnector.classList.remove('mockup-stepper__connector--completed');
    }
    if (stepTab1) {
      stepTab1.classList.remove('mockup-stepper__step--completed');
      stepTab1.classList.add('mockup-stepper__step--active');
      stepTab1.setAttribute('aria-selected', 'true');
    }
  }

  // Complete Mock-Up Request
  function completeRequest() {
    updateSummary();

    // Final background sync with completed status
    try {
      const formData = new FormData(form);
      formData.set('contact[status]', 'Finalized / Photo Upload Confirmed');
      fetch(form.action || '/contact', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).catch(function(e) {});
    } catch (e) {}

    // Reveal Success Panel
    if (panelStep2) panelStep2.style.display = 'none';
    if (panelSuccess) panelSuccess.style.display = 'block';

    if (stepTab2) {
      stepTab2.classList.remove('mockup-stepper__step--active');
      stepTab2.classList.add('mockup-stepper__step--completed');
    }

    // Smooth scroll to success
    const card = document.getElementById('mockup-form-section');
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Step 1 Validation & Progression
  if (continueBtn) {
    continueBtn.addEventListener('click', function(e) {
      e.preventDefault();

      const requiredInputs = [inputName, inputEmail, inputWidth, inputHeight];
      let firstInvalid = null;

      requiredInputs.forEach(function(inp) {
        if (inp && !inp.checkValidity()) {
          inp.setAttribute('aria-invalid', 'true');
          if (!firstInvalid) firstInvalid = inp;
        } else if (inp) {
          inp.removeAttribute('aria-invalid');
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        firstInvalid.reportValidity();
        return;
      }

      goToStep2();
    });
  }

  // Edit Step 1 Button
  if (editStep1Btn) {
    editStep1Btn.addEventListener('click', function(e) {
      e.preventDefault();
      goToStep1();
    });
  }

  // Final Complete Button
  if (finishBtn) {
    finishBtn.addEventListener('click', function(e) {
      e.preventDefault();
      completeRequest();
    });
  }

  // One-Click Copy Reference ID
  if (copyRefBtn) {
    copyRefBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const ref = getOrCreateReferenceId();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText('#' + ref).then(function() {
          const origHTML = copyRefBtn.innerHTML;
          copyRefBtn.innerHTML = '<span>âœ“ Copied!</span>';
          copyRefBtn.style.background = '#dcfce7';
          copyRefBtn.style.color = '#15803d';
          setTimeout(function() {
            copyRefBtn.innerHTML = origHTML;
            copyRefBtn.style.background = '';
            copyRefBtn.style.color = '';
          }, 2000);
        }).catch(function() {});
      }
    });
  }

  // Launch Dropbox Button: auto-copy Reference ID and note opening
  if (dropboxBtn) {
    dropboxBtn.addEventListener('click', function() {
      const ref = getOrCreateReferenceId();
      try {
        sessionStorage.setItem('xwallx_mockup_dropbox_opened', 'true');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText('#' + ref);
        }
      } catch (e) {}
    });
  }

  // Return to Tab Detection
  function handleReturn() {
    try {
      if (sessionStorage.getItem('xwallx_mockup_dropbox_opened') === 'true' && panelStep2 && panelStep2.style.display !== 'none') {
        if (returnPrompt) {
          returnPrompt.style.display = 'block';
        }
      }
    } catch (e) {}
  }

  window.addEventListener('focus', handleReturn);
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) handleReturn();
  });

  // Native validation sync
  form.addEventListener('input', function(e) {
    if (e.target.matches('input[required]') && e.target.checkValidity()) {
      e.target.removeAttribute('aria-invalid');
    }
  });

  // Initialize Reference ID
  getOrCreateReferenceId();
})();